<i class="fa fa-file-pdf click-button" matTooltip="Download em excel" (click)="download()"></i>
<div id="{{container}}"></div>

